/**
 * Shared client check: has this session already finished onboarding?
 */
export function sessionIsOnboarded(data) {
  if (!data || typeof data !== "object") return false;
  if (data.onboardingCompleted === true) return true;
  if (data.onboardingCompletedAt) return true;
  if (data?.onboarding?.completedAt) return true;
  const name = String(data.name || "").trim();
  if (name.length >= 2) return true;
  if (data.trialActive || data.trialEndsAt || data.trialStartedAt) return true;
  if (data.discoverySource || data.hasDiscoverySource) return true;
  const status = String(data.subscriptionStatus || "").toLowerCase();
  if (status === "active" || status === "trialing") return true;
  return false;
}
